<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>
        Quality Control Lab
      </v-toolbar-title>
    </v-toolbar>
    <v-row justify="center">
      <v-col sm="12" md="12">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title class="headline">
              <v-icon left>fas fa-atom</v-icon>Coated Materials
            </v-toolbar-title>
            <v-spacer/>
            <QualityCoatedTicketForm :is-edit="false"/>
            <template v-slot:extension>
              <v-btn small @click="getArchivedCoated" :loading="loadingbatches">
                Get Archived
              </v-btn>
              <v-spacer/>
              <v-text-field
                v-model="searchCoated"
                prepend-inner-icon="search"
                single-line
                hide-details
                clearable
              />
            </template>
          </v-toolbar>
          <QualityCoatedTicketsTable
            :tickets="batchtickets"
            :loading="loadingbatches"
            :search="searchCoated"
          />
        </v-card>
      </v-col>
      <v-col sm="12" md="12">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title class="headline">
              <v-icon left>grain</v-icon>Raw Materials
            </v-toolbar-title>
            <v-spacer/>
            <QualityRawTicketForm :is-edit="false"/>
            <template v-slot:extension>
              <v-btn small @click="getArchivedRaw" :loading="loadingraws">
                Get Archived
              </v-btn>
              <v-spacer/>
              <v-text-field
                v-model="searchRaw"
                prepend-inner-icon="search"
                single-line
                hide-details
                clearable
              />
            </template>
          </v-toolbar>
          <QualityRawTicketsTable
            :tickets="rawtickets"
            :loading="loadingraws"
            :search="searchRaw"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { BatchTicket } from "../../models/Ticket";
import { RawTicket } from "../../models/Ticket";
import QualityRawTicketsTable from "../../components/Quality/QualityRawTicketsTable";
import QualityCoatedTicketsTable from "../../components/Quality/QualityCoatedTicketsTable";
import QualityCoatedTicketForm from "../../components/Quality/QualityCoatedTicketForm";
import QualityRawTicketForm from "../../components/Quality/QualityRawTicketForm";
export default {
  name: "Quality",
  components: {
    QualityRawTicketForm,
    QualityCoatedTicketForm,
    QualityCoatedTicketsTable,
    QualityRawTicketsTable
  },
  data() {
    return {
      loadingbatches: true,
      loadingraws: true,
      searchCoated: "",
      searchRaw: ""
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    batchtickets() {
      return BatchTicket.all();
    },
    rawtickets() {
      return RawTicket.all();
    }
  },
  methods: {
    initialize() {
      this.loadingbatches = true;
      this.loadingraws = true;
      BatchTicket
        .$fetchActive()
        .then(() => this.loadingbatches = false);
      RawTicket
        .$fetchActive()
        .then(() => this.loadingraws = false);
    },
    getArchivedCoated() {
      this.loadingbatches = true;
      BatchTicket
        .$fetchAll()
        .then(() => this.loadingbatches = false);
    },
    getArchivedRaw() {
      this.loadingraws = true;
      RawTicket
        .$fetchAll()
        .then(() => this.loadingraws = false);
    }
  }
};
</script>
